import TeeTimes from './dashboard/teetimes.vue';
import Forms from './dashboard/forms.vue';
import Players from './dashboard/players.vue';
import Navigation from './dashboard/navigation.vue';

const dashboardRoutes = [
  // {
  //   path: '/',
  //   component: TeeTimes,
  // },
  // {
  //   path: '/TeeTimes',
  //   component: TeeTimes,
  // },
  // {
  //   path: '/Forms',
  //   component: Forms,
  // },
  // {
  //   path: '/Navigation',
  //   component: Navigation,
  // },
  // {
  //   path: '/Players',
  //   component: Players,
  // },
];

export default dashboardRoutes;
